import * as React from 'react';
import * as GlobalLoader from '../../utils/GlobalLoader';

export interface LoaderEnhancerProperties {
    loading: boolean;
}

export type WithLoaderProperties<T> = T & LoaderEnhancerProperties;

interface LoaderEnhancerState {
    loading: boolean;
}

class Loader extends React.Component<LoaderEnhancerProperties, any> {

}
const EmptyLoader = withLoader(Loader, 'emptyLoader');
export { EmptyLoader };

let lastId = 0;

export function withLoader<P>(
    Component: React.ComponentType<P>,
    loaderName: string
): React.ComponentType<P & LoaderEnhancerProperties> {
    return class LoaderEnhancer extends React.Component<P & LoaderEnhancerProperties, LoaderEnhancerState> {
        static getDerivedStateFromProps(nextProps: LoaderEnhancerProperties, prevState: LoaderEnhancerState) {
            if (nextProps.loading !== prevState.loading) {
                if (nextProps.loading && !prevState.loading) {
                    GlobalLoader.showGlobalLoader(loaderName);
                } else {
                    GlobalLoader.hideGlobalLoader(loaderName);
                }
            }
            return {
                loading: nextProps.loading
            };
        }

        constructor(props: any) {
            super(props);

            loaderName = loaderName + (lastId++);

            this.state = {
                loading: false
            };
        }

        componentWillUnmount() {
            GlobalLoader.hideGlobalLoader(loaderName);
        }

        render() {
            return (
                <React.Fragment>
                    {!this.props.loading ? <Component {...this.props} /> : null}
                </React.Fragment>
            );
        }
    };
}



// WEBPACK FOOTER //
// ./src/webportal/components/hocs/LoaderEnhancer.tsx